import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-CalibrationReceptionList',
  templateUrl: './CalibrationReceptionList.component.html',
  styleUrls: ['./CalibrationReceptionList.component.css']
})
export class CalibrationReceptionListComponent implements OnInit {

  Token:String=""
  page:number=0;
  Procssing:boolean=false;
  BaseUrl:string=environment.BaseUrl
  Selected_Calibration_Id:number=-1

  StartSearchDate:string=""
  EndSearchDate:string=""
  SubmitPeriodDate:string="1"

  constructor(
    private Calibration_Service:CalibrationService,
    private http:HttpClient,
    private Nav_Service:NavService,
    private Alerify:AlertifyService,
    private modalService: BsModalService,
  ) { }


  DataList_Calibration:Array<Calibration_List_Interface>=[]
  DataList_Calibration_Excel:Array<any>=[]
  Selected_DataList_Calibration:Calibration_List_Interface=Empty_Calibration_List_Interface()

  ngOnInit() {
    localStorage.removeItem('Daro_User_Comment')
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,4).subscribe(
      data=>{
        this.Read_GetDetailCount()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  Filter_customer:String=''
  Filter_code:String=''

  ReadData_Calibration(StartSearchDate,EndSearchDate){
    this.Procssing=true

    this.StartSearchDate=StartSearchDate
    this.EndSearchDate=EndSearchDate



    this.Calibration_Service.GetRecord(
      StartSearchDate,
      EndSearchDate,
      this.Filter_customer,
      this.Filter_code,
      '',
      this.SubmitPeriodDate,
      this.Token,
      false).subscribe(
      data=>{

        this.DataList_Calibration=data['result']
        this.DataList_Calibration_Excel=data['excel']
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  modalRef_upload: any;
  ProcssingUpload:boolean=false

  openModal_upload(template: TemplateRef<any>,item) {
    this.modalRef_upload = this.modalService.show(template);
    this.Selected_DataList_Calibration=item
  }



  current_Month:number=0
  current_Year:number=0
  last_Month:number=0

  Read_GetDetailCount(){
    this.Calibration_Service.GetDetailCount(this.Token,false).subscribe(
      data=>{
        this.current_Month=data['current_Month']
        this.current_Year=data['current_Year']
        this.last_Month=data['last_Month']
      }
    )
  }


  RejectDsc:string=''
  modalRef_Delete: any;
  Data_Seleted_Delete:Calibration_List_Interface=Empty_Calibration_List_Interface()
  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }



  Delete(item:Calibration_List_Interface){
    this.modalRef_Delete.hide()
    this.Calibration_Service.DeleteCalibration(item.id,this.RejectDsc,this.Token).subscribe(
      data=>{
        this.Alerify.SuccessMessage("Deleted successfully.")
        this.ReadData_Calibration(this.StartSearchDate,this.EndSearchDate)
        this.RejectDsc=''
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroCalibration.xlsx");

  }


  OnSet_Selected_Calibration_Id(id:number){
    this.Selected_Calibration_Id=id
  }

  OnSet_Back_Calibration_Id(id:number){
    this.Selected_Calibration_Id=id
  }

}


